import { useQuery } from "@tanstack/react-query";
import { apiFetch } from "@core/index";
import { IGetAllPublishers } from "../utils/types";
import { apiEndpoint } from "../utils/constants";
import { enqueueSnackbar } from "notistack";
import { PublisherRow } from "../utils/types";
import { buildQueryParams } from "@shared/utils/functions";

export type PublishersListResponse = {
  data: PublisherRow[];
  pagination: {
    total: number;
    pageNumber: number;
    pageSize: number;
    totalPages: number;
  };
};

export const useGetAllPublishers = (config: IGetAllPublishers) => {
  return useQuery<
    PublishersListResponse,
    Error,
    PublishersListResponse,
    (string | boolean | undefined)[]
  >({
    queryKey: [
      "publishers",
      config.data.pageNumber,
      config.data.pageSize,
      config.data.searchQuery ?? "",
      config.data.orderBy ?? "",
      config.data.order ?? "",
      config.data.updatedSince ?? "",
    ],
    queryFn: async () => {
      const queryString = buildQueryParams({
        ...config.data,
        includeInactive: false,
      });

      const url = `${apiEndpoint}?${queryString}`;

      try {
        const data = await apiFetch<PublishersListResponse>(url);
        return data;
      } catch (error) {
        const message =
          error instanceof Error
            ? error.message
            : "Failed to fetch the Publisher Parties List.";

        enqueueSnackbar(message, {
          variant: "error",
          autoHideDuration: 5000,
          preventDuplicate: true,
        });
        throw error;
      }
    },

    placeholderData: (prev) => prev,
    staleTime: 0,
    refetchOnWindowFocus: false,
  });
};
